<template>
    <div>
        <div class="d-flex align-items-center">
            <b-spinner variant="primary" class="loading-spinner" label="Spinning" small></b-spinner>
            <strong class="text-primary loading-text faa-flash animated faa-slow">Loading...</strong>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

.loading-spinner
{
    margin-right: 5px;
}

// .loading-text
// {

// }

</style>